<template>
  <nx-bform
    ref="form"
    @submit="onSubmit"
    class="e-registration-professional-register-form"
  >
    <h5>
      {{ $t("title") }}
    </h5>
    
    <p class="text-muted">
      {{ $t("titleDesc") }}
    </p>
    <!-- <nx-bform-server-errors /> -->
    <div class="mb-2" style="color:#dc3545;font-size: 80%;margin-top: 0.25rem;">
      {{errorMsg}}
    </div>
    
    <hr />
    <ERegistrationPublicTermCond v-model="accepted" />
    <div class="mb-2" style="color:#dc3545;font-size: 80%;margin-top: 0.25rem;">
      {{errorMsg}}
    </div>
    <b-button type="submit" class="bd-button mr-2" v-t="'send'" />
    <b-button variant="danger" @click="resetForm" v-t="'cancel'" />
  </nx-bform>
</template>

<script>
import { assign } from "lodash";
import { EshApi,MemberRegistrationApi } from "@/api";
import moment from "moment";
import { FileUtil } from "nx-libs";
import { CommonUtil } from "@/utils";
import ERegistrationPublicTermCond from "./ERegistrationPublicTermCond";
import RegistrationHKIDNumberFormGroup from "@/forms/registration/RegistrationHKIDNumberFormGroup";
//import RegistrationDateOfBirthFormGroup from "@/forms/registration/RegistrationDateOfBirthFormGroup";
import RegistrationESignatureFormGroup from "@/forms/registration/RegistrationESignatureFormGroup";
import CaptchaFormGroup from "@/forms/common/CaptchaFormGroup";
import ManageCertProfessionalFormGroup from '@/pages/manage-cert/components/ManageCertProfessionalFormGroup.vue';
import { v4 as uuidv4 } from 'uuid';
import { translateResponseError } from "@/utils/translate-response-error";

export default {
  props: [ "businessId"],
  components: {
  ERegistrationPublicTermCond,
    RegistrationHKIDNumberFormGroup,
    ManageCertProfessionalFormGroup,
    //RegistrationDateOfBirthFormGroup,
    RegistrationESignatureFormGroup,
    CaptchaFormGroup
  },
  data() {
    return {
      form: this.getForm(),
      accepted: false,
      hkidDisable:false,
      guid:uuidv4(),
      autoLogout:true,
      errors: [],
      errorMsg: ''
    };
  },
  computed: {
    profOptions() {
      return [
        { text: "Authorized Person", value: "AP" },
        { text: "Registration Structure Engineer", value: "RSE" },
        { text: "Registered Geotechnical Engineer", value: "RGE" }
      ];
    }
  },
  mounted() {
    this.$watch(
      () => {
        this.errors = this.$refs.form.observer.errors['server-errors']
    }) 
  },
  watch: {
    errors(errors) {
      // document.getElementsByClassName('main-content')[0].scrollTop = 0;
      if (errors){
        $('.form-control.is-invalid:first')[0].offsetParent.scrollIntoView({behavior: 'smooth'});
      }
    },
  },
  async created(){

  },  
  methods: {
    getForm() {
      return {
        idDoc: "hkid",
        //dateOfBirth: "",
        eCert: null,
        captcha: "",
        captchaToken: ""
      };
    },
    resetForm() {
      this.form = this.getForm();
      this.$refs.form.reset();
      this.$router.push({name:"LoginPublic"});
    },
    async onSubmit(evt) {
      console.log("Check T&C", this.businessId);
      try {

        this.$router.push({
          name: "ERegistrationPublicMemberRegister",
          params: {
            businessId : this.businessId
          }
        });
      } catch(ex) {
        if (ex.response && ex.response.data != null) {
          this.errorMsg = translateResponseError(this, ex.response.data);
        }
        throw ex;
      }
      finally
      {
        this.$spinner.hide();
      }
      
    },
    setHKID(isDisable)
    {
      this.hkidDisable = isDisable;
    },
  }
};
</script>

<style lang="scss" scoped></style>

<i18n src="@/locales/actions.locale"></i18n>

<i18n src="@/locales/responseMsg.locale"></i18n>

<i18n>
{
  "en": {
    "title": "Activating a user account of Electronic Submission Hub",
    "titleDesc": "If you are an authorized person/ registered structural engineer/ registered geotechnical engineer or an authorized signatory of registered general building contractors/registered specialist contractor under the Buildings Ordinance and want to become a user of ESH, please complete the following application form. All fields with (*) are mandatory."
  },
  "zh_hk": {
    "title": "啟用成為電子資料呈交及處理系統的用戶",
    "titleDesc": "假如你是《建築物條例》下的 認可人士/註冊結構工程師/註冊岩土工程師/註冊一般建築承建商/註冊專門承建商，並要成為電子資料呈交及處理系統的用戶，請填寫以下申請表格。帶（*）的所有字段均為必填項。"
  },
  "zh_cn": {
    "title": "申请作为电子提交中心的专业用户激活",
    "titleDesc": "假如你是《建筑物条例》下的 认可人士/注册结构工程师/注册岩土工程师/注册一般建筑承建商/注册专门承建商，并要成为电子资料呈交及处理系统的用户，请填写以下申请表格。带（*）的所有字段均为必填项。"
  }
}
</i18n>
